module.exports = __webpack_public_path__ + "static/media/dropoff-timer.d186a78f.svg";